import React, { useEffect, useState } from "react";
import { useBooking } from "../../context/BookingContext";
import { usePlayrooms } from "../../context/PlayroomsContext";
import { Card, Button, Checkbox, Spin } from "antd";
import { useNavigate } from "react-router-dom";

const { Meta } = Card;

export default function PackageSelection() {
  const { bookingState, updateBooking } = useBooking();
  const { choosenPlayroom } = usePlayrooms();
  const [selectedPackage, setSelectedPackage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (bookingState.from === null || bookingState.to === null) {
      navigate("/");
    }
    if (bookingState.packageId !== "") {
      setSelectedPackage(bookingState.packageId);
    }
  }, [bookingState.from, bookingState.to, bookingState.packageId, navigate]);

  const handlePackageSelect = (pkgId) => {
    setSelectedPackage(pkgId);
  };

  const onsubmit = (packageId) => {
    
    updateBooking("packageId", packageId);
    navigate("/reservation-form");
  };

  if (bookingState.from === null || bookingState.to === null) {
    return <Spin />;
  }

  return (
    <div className="min-h-screen flex flex-col justify-start items-center ">
      <div className="w-full text-center py-10">
        <p className="text-3xl lg:text-6xl font-bold text-footerBlue">
          {choosenPlayroom?.name || "Selected Playroom"}
        </p>
        <label
          className="block text-footerBlue font-semibold text-xl lg:py-4"
          htmlFor="expectedNumberOfAdults"
        >
          Izaberite paket za proslavu rođendana:
        </label>
      </div>

      <div className="container mx-auto p-4">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 px-4">
          {choosenPlayroom?.packages?.map((pkg, index) => (
            <div
              key={index}
              className="bg-datepickerGray p-6 rounded-[35px] shadow-md space-y-4 flex flex-col justify-between min-h-[350px]"
            >
              <div>
                <h3 className="text-2xl md:text-3xl font-bold mb-2 text-footerBlu">
                  {pkg.packageName}
                </h3>
                <ul className="list-disc ml-5 mt-2 text-left text-footerBlue p-2 text-xs md:text-sm">
                  {pkg?.offers?.map((offer, idx) => (
                    <li key={idx}>{offer}</li>
                  ))}
                </ul>
              </div>
              <Button
                onClick={() => onsubmit(pkg.id)}
                type="submit"
                className="bg-buttonYellow text-footerBlue hover:bg-footerBlue hover:text-white w-60 h-10 rounded-[36px] font-bold text-xl self-center"
              >
                ODABERI PAKET
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
